import React from 'react';

// Neural brain SVG mark — no circular background
export default function BrainLogo({ id = 'nav', size = 46 }) {
  const l = `bL${id}`;
  const r = `bR${id}`;
  const g = `ng${id}`;

  return (
    <svg
      viewBox="0 0 56 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={l} x1="0%" y1="0%" x2="100%" y2="110%">
          <stop offset="0%" stopColor="#00FF87" />
          <stop offset="45%" stopColor="#00C853" />
          <stop offset="100%" stopColor="#004D20" />
        </linearGradient>
        <linearGradient id={r} x1="110%" y1="0%" x2="0%" y2="110%">
          <stop offset="0%" stopColor="#00E676" />
          <stop offset="48%" stopColor="#00A843" />
          <stop offset="100%" stopColor="#003D18" />
        </linearGradient>
        <filter id={g} x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="0.9" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Left hemisphere */}
      <path
        d="M28 4 C21 4,14 7.5,10 12 C6 16,4.5 21,5 27 C3.5 29.5,3 33,4 36.5 C3 39,3.5 42.5,6 44.5 C8 46,11 45.8,13 44 C15 46,17.5 47,20.5 46.5 C23 46,25 44,25.5 41.5 C26.5 42,27.2 42,28 42 L28 4Z"
        fill={`url(#${l})`}
      />
      {/* Right hemisphere */}
      <path
        d="M28 4 C35 4,42 7.5,46 12 C50 16,51.5 21,51 27 C52.5 29.5,53 33,52 36.5 C53 39,52.5 42.5,50 44.5 C48 46,45 45.8,43 44 C41 46,38.5 47,35.5 46.5 C33 46,31 44,30.5 41.5 C29.5 42,28.8 42,28 42 L28 4Z"
        fill={`url(#${r})`}
        opacity=".95"
      />

      {/* Median fissure */}
      <line x1="28" y1="4.5" x2="28" y2="42" stroke="rgba(255,255,255,.42)" strokeWidth="1" strokeDasharray="2 1.8" strokeLinecap="round" />

      {/* Sulci left */}
      <path d="M16 10 Q13 14.5,14 20" stroke="rgba(255,255,255,.46)" strokeWidth="1.1" fill="none" strokeLinecap="round" />
      <path d="M8 22 Q6.5 27,7.5 32" stroke="rgba(255,255,255,.36)" strokeWidth="1" fill="none" strokeLinecap="round" />
      <path d="M7 35 Q6 39,8 42" stroke="rgba(255,255,255,.28)" strokeWidth=".9" fill="none" strokeLinecap="round" />
      <path d="M21 7 Q19 12,20 17" stroke="rgba(255,255,255,.24)" strokeWidth=".85" fill="none" strokeLinecap="round" />
      {/* Sulci right */}
      <path d="M40 10 Q43 14.5,42 20" stroke="rgba(255,255,255,.46)" strokeWidth="1.1" fill="none" strokeLinecap="round" />
      <path d="M48 22 Q49.5 27,48.5 32" stroke="rgba(255,255,255,.36)" strokeWidth="1" fill="none" strokeLinecap="round" />
      <path d="M49 35 Q50 39,48 42" stroke="rgba(255,255,255,.28)" strokeWidth=".9" fill="none" strokeLinecap="round" />
      <path d="M35 7 Q37 12,36 17" stroke="rgba(255,255,255,.24)" strokeWidth=".85" fill="none" strokeLinecap="round" />

      {/* Brain stem */}
      <path d="M23.5 42.5 Q25 47,25 51 L31 51 Q31 47,32.5 42.5" fill="none" stroke="#00A046" strokeWidth="1.5" strokeLinecap="round" />
      <rect x="24" y="50.5" width="8" height="2.8" rx="1.4" fill="#00B14F" opacity=".5" />

      {/* Neural nodes */}
      <circle cx="28" cy="8"  r="2.2" fill="#fff"    filter={`url(#${g})`} opacity=".96" />
      <circle cx="16" cy="14" r="1.9" fill="#69F0AE" filter={`url(#${g})`} opacity=".92" />
      <circle cx="40" cy="14" r="1.9" fill="#69F0AE" filter={`url(#${g})`} opacity=".92" />
      <circle cx="9"  cy="26" r="1.6" fill="#00E676" filter={`url(#${g})`} opacity=".86" />
      <circle cx="47" cy="26" r="1.6" fill="#00E676" filter={`url(#${g})`} opacity=".86" />
      <circle cx="20" cy="23" r="1.5" fill="#B9F6CA" filter={`url(#${g})`} opacity=".82" />
      <circle cx="36" cy="23" r="1.5" fill="#B9F6CA" filter={`url(#${g})`} opacity=".82" />
      <circle cx="11" cy="38" r="1.3" fill="#00C853" filter={`url(#${g})`} opacity=".78" />
      <circle cx="45" cy="38" r="1.3" fill="#00C853" filter={`url(#${g})`} opacity=".78" />

      {/* Synapse connections */}
      <line x1="28" y1="8"  x2="16" y2="14" stroke="#00E676" strokeWidth=".9" strokeOpacity=".65" />
      <line x1="28" y1="8"  x2="40" y2="14" stroke="#00E676" strokeWidth=".9" strokeOpacity=".65" />
      <line x1="16" y1="14" x2="20" y2="23" stroke="#69F0AE" strokeWidth=".8" strokeOpacity=".55" />
      <line x1="16" y1="14" x2="9"  y2="26" stroke="#00C853" strokeWidth=".75" strokeOpacity=".5" />
      <line x1="20" y1="23" x2="11" y2="38" stroke="#00B14F" strokeWidth=".7" strokeOpacity=".46" />
      <line x1="9"  y1="26" x2="11" y2="38" stroke="#00E676" strokeWidth=".7" strokeOpacity=".44" />
      <line x1="40" y1="14" x2="36" y2="23" stroke="#69F0AE" strokeWidth=".8" strokeOpacity=".55" />
      <line x1="40" y1="14" x2="47" y2="26" stroke="#00C853" strokeWidth=".75" strokeOpacity=".5" />
      <line x1="36" y1="23" x2="45" y2="38" stroke="#00B14F" strokeWidth=".7" strokeOpacity=".46" />
      <line x1="47" y1="26" x2="45" y2="38" stroke="#00E676" strokeWidth=".7" strokeOpacity=".44" />

      {/* Corpus callosum bridges */}
      <line x1="20" y1="23" x2="36" y2="23" stroke="#00E676" strokeWidth=".65" strokeOpacity=".3" strokeDasharray="2 1.5" />
      <line x1="11" y1="38" x2="45" y2="38" stroke="#00E676" strokeWidth=".65" strokeOpacity=".26" strokeDasharray="2 1.5" />
    </svg>
  );
}
